// import * as Cookies from "js-cookie";

export default {

     /* eslint-disable */

  init() {
    function setCookie(cname,cvalue,exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function areCookiesEnabled() {
        document.cookie = "__verify=1";
        var supportsCookies = document.cookie.length >= 1 &&
                              document.cookie.indexOf("__verify=1") !== -1;
        var thePast = new Date(1976, 8, 16);
        document.cookie = "__verify=1;expires=" + thePast.toUTCString();
        return supportsCookies;
      }
      

    function welcomeBannerCookie() {
        var welcomeCookie=getCookie("noShowWelcome");
        if (welcomeCookie == "true") {
            $('.intro').hide();
            $(".intro").removeClass('d-flex');
        }
        else {
            console.log('no cookie found')
            $('.intro').addClass('welcome');

            setTimeout(function(){ 

                $(".intro").removeClass('welcome');
                setCookie("noShowWelcome", "true", 1);

             }, 5000);
        }
    };


    $(document).ready(function() {
        if ( areCookiesEnabled() ) {
          console.log('Cookies are enabled.');
          welcomeBannerCookie();
        } else {
         console.log('Cookies are disabled');
         $(".intro").removeClass('welcome');
        }
      });
    

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Define Constants

    var body = document.body;
    var menuToggle = document.getElementById("menuToggle");
    // var backTop = document.getElementById("backTop");

    // Menu Toggle

    function menuAnimation() {
      if (body.classList.contains('menu-open')) {
          body.classList.remove('menu-open');
          menuToggle.classList.remove('is-active');
      } else {
          body.classList.add('menu-open');
          menuToggle.classList.add('is-active');
      }
    }

    menuToggle.addEventListener("click", menuAnimation, false);

    function scrollTo(element, to = 0, duration= 1000) {
        var start = element.scrollTop;
        var change = to - start;
        var increment = 20;
        var currentTime = 0;

        const animateScroll = (() => {
            currentTime += increment;

            const val = Math.easeInOutQuad(currentTime, start, change, duration);

            element.scrollTop = val;

            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        });

        animateScroll();
    }

    Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
    };

  

    $('button.back-top').click(function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

    //   Landing Page - Smooth Scroll


    $('.page-template-landing-page a.btn[href*="#"]:not([href="#"])').click(function() {

    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top,
        }, 800);
        return false;
        }
    }
    }); 

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js